import { HTMLAttributes } from 'react';
import merge from 'classnames';

import { SvgIconContainer } from '@/components/generic/SvgIconContainer';

import { SvgIconContainerIconProps } from '../types';

type IconCloseProps = HTMLAttributes<HTMLSpanElement> & SvgIconContainerIconProps;

export const IconClose = ({
  classes = {},
  color = '#CCCCCC',
  ...containerProps
}: IconCloseProps) => (
  <SvgIconContainer role="img" {...containerProps} className={merge(classes.container)}>
    <svg fill="none" height="29" viewBox="0 0 29 29" width="29" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.44177 2L27 27.5582" stroke={color} strokeWidth="4" />
      <path d="M1.44177 27.5586L27 2.00034" stroke={color} strokeWidth="4" />
    </svg>
  </SvgIconContainer>
);
